// extracted by mini-css-extract-plugin
module.exports =  {"container":"HeaderTitle-module__container___sGZJr","title":"HeaderTitle-module__title___gJBC1"};